import { ALL_ELEMENTS } from "@/data";
import type { ForceElement } from "@/types/force";
import { groupModelsByProfile } from "@/utils/grouping";
import { SoldierStatCard } from "./SoldierStatCard";

interface PrintElementCardProps {
	element: ForceElement;
}

export function PrintElementCard({ element }: PrintElementCardProps) {
	const template = ALL_ELEMENTS.find((t) => t.id === element.templateId);
	const elementName = template?.name ?? element.templateId;
	const groups = groupModelsByProfile(element);

	return (
		<div className="print-element-card mb-4 break-inside-avoid-page">
			{/* Element Header */}
			<div className="flex items-center gap-2 mb-2">
				<h3 className="text-sm font-bold text-gray-900 uppercase tracking-wide">
					{elementName}
				</h3>
				<span className="text-xs text-gray-500">
					({element.models.length} model{element.models.length !== 1 ? "s" : ""})
				</span>
			</div>

			{/* Grouped Stat Cards */}
			<div className="space-y-2">
				{groups.map((group, idx) => (
					<SoldierStatCard
						key={`${group.role}-${idx}`}
						group={group}
						elementName={elementName}
					/>
				))}
			</div>
		</div>
	);
}
